import { MigrationsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const migrationsApi = MigrationsApi({}, '/api', axiosInstance);
